import React from "react";

import {
  faInstagramSquare,
  faLinkedin,
  faSquareFacebook,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Image, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import FaMail from "../assets/icons/faMail.svg";
import FaMapMarker from "../assets/icons/faMapMarker.svg";
import i18n from "../i18n";

const FooterComponent = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();
  const year = new Date().getFullYear();
  const email = import.meta.env.VITE_SALES_EMAIL ?? "";
  const address = "618 Av. Meloche, Dorval, QC H9P 2P4";
  const googleMap = "https://maps.app.goo.gl/hLsSuZKwaGbW984R6";
  const rbq = "5840-0672-01";

  return (
    <Container fluid className="footerContainer">
      <Container>
        <div className="footerFlex">
          <Row style={{ paddingTop: "4rem" }}>
            <Col className="text-centert text-lg-start" xs={12}>
              <Image
                alt="PakVille™"
                height={39}
                src="/images/logo/pakville.svg"
                style={{ maxWidth: "250px" }}
                width={206}
              />
            </Col>

            <Col xs={12}>
              <div className="footerContactInfoContainer">
                {t("_footer_contact_note")}
              </div>
            </Col>

            <Col xs={12}>
              <div className="footerContactInfoContainer">
                <div>
                  <img alt={t(`email`)} src={FaMail} />
                  <a href={`mailto:${email}`} rel="noreferrer">
                    {email}
                  </a>
                </div>
                <div>
                  <img alt={t(`address`)} src={FaMapMarker} />
                  <a href={googleMap} rel="noreferrer" target="_blank">
                    {address}
                  </a>
                </div>
              </div>
            </Col>

            <Col className="text-centert text-lg-start" xs={12}>
              <hr
                className="ms-auto me-auto mt-4 mb-4 ms-lg-0"
                style={{ width: "60px" }}
              />
              <div>RBQ #: {rbq}</div>

              <hr
                className="ms-auto me-auto mt-4 mb-4 d-block d-lg-none"
                style={{ width: "60px" }}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Image
                alt="PakVille-Patent"
                className="aspectImg aspectImg--4x3"
                loading="lazy"
                src="/images/PakVille_Patent_pending_badge.png"
                style={{ maxWidth: "300px" }}
              />
            </Col>
          </Row>
        </div>

        <hr />

        <Row style={{ paddingBottom: "4rem" }}>
          <Col className="order-3 order-lg-1" lg={4} xs={12}>
            <div className="footerCopyrightContainer">
              {t("copyright")} © {year} PakVille™ Construction Corp,{" "}
              {t("all_rights_reserved")}
            </div>
          </Col>

          <Col className="order-2" lg={4} xs={12}>
            <div className="footerSocialMediaContainer">
              <a
                href="https://www.youtube.com/channel/UCOETzq4CMluyhH87DrwMW5g"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon color="gray" icon={faYoutube} size="2x" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61552975003426"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  color="gray"
                  icon={faSquareFacebook}
                  size="2x"
                />
              </a>
              <a
                href="https://www.instagram.com/pakville"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon
                  color="gray"
                  icon={faInstagramSquare}
                  size="2x"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/pakville"
                rel="noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon color="gray" icon={faLinkedin} size="2x" />
              </a>
            </div>
          </Col>

          <Col className="order-1 order-lg-3" lg={4} xs={12}>
            <div className="footerPrivacyContainer">
              <NavLink
                className="text-center text-lg-end"
                to={`${langPrefix}/${t("_route.terms-of-service")}`}
              >
                {t("terms_of_service")}
              </NavLink>
              <NavLink
                className="text-center text-lg-end"
                to={`${langPrefix}/${t("_route.privacy-policy")}`}
              >
                {t("privacy_policy")}
              </NavLink>
              <NavLink
                className="text-center text-lg-end"
                to={`${langPrefix}/${t("_route.refund-policy")}`}
              >
                {t("refund_policy")}
              </NavLink>
              <NavLink
                className="text-center text-lg-end"
                to={`${langPrefix}/${t("_route.reservation-agreement")}`}
              >
                {t("Reservation Agreement")}
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default FooterComponent;
